import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/tud-nmc-dark.svg");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar","SidebarIconButton"] */ "/app/src/components/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeviceTypeProvider"] */ "/app/src/hooks/device.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TagsProvider"] */ "/app/src/hooks/tags.tsx");
